// extracted by mini-css-extract-plugin
export default {"header":"ESGPlatformHeader_header__9Jffa"};